var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKanapa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 400,
    viewBox: "0 -90 500 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57 177.88L193.46 232.47L456.58 158.42",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.59 141.3L456.58 158.42",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.58 158.42C459.33 164.35 460.9 170.93 460.9 177.9C460.9 184.87 459.32 191.45 456.58 197.38L193.46 271.43L8.58 216.83C5.83 210.9 4.26 204.32 4.26 197.35C4.26 190.38 5.84 183.8 8.58 177.87L202.85 123.2",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.46 232.47C196.21 238.4 196.21 265.5 193.46 271.43",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.12 221.14V260.1",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.38 272.32V311.28",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.92 204.42V243.39",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.97 146V70.2L230.12 39.2",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.49 64.94L456.58 82.09V158.42",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.11 82.36C229.5 74.41 228.64 66.18 228.64 57.75C228.64 38.93 232.9 21.14 240.32 5.12L392.21 49.96C399.63 65.98 403.89 83.77 403.89 102.59C403.89 121.41 399.63 139.2 392.21 155.22L330.75 137.07",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.21 49.96C384.79 65.98 380.53 83.77 380.53 102.59C380.53 121.41 384.79 139.2 392.21 155.22",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.64 76.75L323.51 110.67C327.82 119.98 330.29 130.31 330.29 141.24C330.29 152.17 327.82 162.5 323.51 171.81L208.64 137.89C204.33 128.58 201.86 118.25 201.86 107.32C201.86 96.39 204.33 86.06 208.64 76.75Z",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.52 110.68C319.21 119.99 316.74 130.32 316.74 141.25C316.74 152.18 319.21 162.51 323.52 171.82",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 465.16,
    height: 311.28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanapa);
export default __webpack_public_path__ + "static/media/kanapa.51b4577c61ea7ddbe408e0c82514f694.svg";
export { ForwardRef as ReactComponent };